import React from 'react';
import config from '../config';
import {SelectInput} from 'react-admin';
import { getChoices } from '../util';

const EntranceTypeInput = (props) =>  (
        <SelectInput {...props} choices={getChoices(config.entrance_types)} />
);

export default EntranceTypeInput;